const amplifyConfig = {
  aws_project_region: "us-east-1",
  aws_cognito_region: "us-east-1",

  // aws_user_pools_id: "us-east-1_nKLjopnTS", // Clinic User pool ID
  // aws_user_pools_web_client_id: "1tmf4qvp0m94oan3cqq4u37k6q", // Clinic User pool client ID

  aws_user_pools_id: "us-east-1_EJYK0nKV0", // CMS User pool ID
  aws_user_pools_web_client_id: "2fpp97fj08g458r979829sqmar", // CMS User pool client ID

  // aws_user_pools_id: "us-east-1_xoMu6hBQn", // Radiologist User pool ID
  // aws_user_pools_web_client_id: "5bud9dlcptsimfcm55ke03nrg4", // Radiologist User pool client ID
  
  federationTarget: "COGNITO_USER_POOLS",
  authenticationFlowType: 'CUSTOM_AUTH',
};
export default amplifyConfig;